// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export { useInstrumenter } from "./instrumenter.js";
export { createTracingClient } from "./tracingClient.js";
//# sourceMappingURL=index.js.map